export enum EQuestionAnswerType {
    Boolean
}